import './js/debugOverlay.js';
import './js/userInteractionLogger.js';
import './style.css';
import './css/style.scss';
// Swiper core styles
import 'swiper/css';
import 'swiper/css/navigation';

// Remove FOUC-hiding class once styles are applied
try {
	requestAnimationFrame(() => {
		const html = document.documentElement;
		if (html.classList.contains('css-loading')) {
			html.classList.remove('css-loading');
		}
	});
} catch(_) {}

// Optional: basic client-side enhancement placeholder
console.log('Vite initialized');

import audioPlayer from './js/audioPlayer.js';
import nav from './js/nav.js';
import slideshowModal from './js/slideshowModalNew.js';


nav.init();
slideshowModal.init();

// Initialize audio player on page load so Lottie waveform renders immediately
try { audioPlayer.init(); } catch(_) {}

// Tag html with iOS Safari/Chrome for CSS overrides
(function tagIOSBrowsers(){
	try {
		const ua = navigator.userAgent || '';
		const isIOSDevice = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
		const isEdgeIOS = /EdgiOS/i.test(ua);
		const isFirefoxIOS = /FxiOS/i.test(ua);
		// Chrome on iOS typically exposes "CriOS", but some builds show "Chrome/" on iOS
		const isChromeAgent = /CriOS/i.test(ua) || (/Chrome\/[0-9.]+/i.test(ua) && /Mobile/i.test(ua));
		const isChromeIOS = isIOSDevice && isChromeAgent && !isEdgeIOS && !isFirefoxIOS;
		const isSafariIOS = isIOSDevice && !isChromeIOS && !isEdgeIOS && !isFirefoxIOS;
		const html = document.documentElement;
		if (isChromeIOS) html.classList.add('ios-chrome');
		if (isSafariIOS) html.classList.add('ios-safari');
	} catch(_) {}
})();

// On first user interaction anywhere, initialize audio and start track 1
// Ensures autoplay isn't missed due to lazy init timing
const _autoAudioGesture = () => {
	try { audioPlayer.init(); } catch(_) {}
	// Attempt immediate start; if tracks not ready, poll briefly
	const tryStart = () => {
		try {
			if (audioPlayer.tracks && audioPlayer.tracks.length && audioPlayer.currentIndex === -1) {
				audioPlayer.playIndex(0);
				cleanup();
				return true;
			}
		} catch(_) {}
		return false;
	};
	const cleanup = () => {
		window.removeEventListener('pointerdown', _autoAudioGesture);
		window.removeEventListener('keydown', _autoAudioGesture);
	};
	if (tryStart()) return;
	let attempts = 0;
	const timer = setInterval(() => {
		attempts++;
		if (tryStart() || attempts > 20) {
			clearInterval(timer);
			cleanup();
		}
	}, 100);
};
window.addEventListener('pointerdown', _autoAudioGesture, { once: true });
window.addEventListener('keydown', _autoAudioGesture, { once: true });


// Clear any persistent hotspot highlight ('.tapped') when the user scrolls
function clearTapped() {
	const tapped = document.querySelectorAll('#cropped-images svg [tabindex].tapped');
	if (tapped.length) {
		tapped.forEach(el => el.classList.remove('tapped'));
	}
}

// Listen for scroll-related interactions on various inputs
window.addEventListener('scroll', clearTapped, { passive: true });
document.addEventListener('scroll', clearTapped, { passive: true, capture: true });
window.addEventListener('wheel', clearTapped, { passive: true });
window.addEventListener('touchmove', clearTapped, { passive: true });

// Rotate overlay: show on mobile landscape, hide during any fullscreen video
(function initRotateMessage(){
	const rotateEl = document.querySelector('.rotate-message');
	if (!rotateEl) return;
	const isPhone = () => {
		try {
			const ua = navigator.userAgent || '';
			const iPhone = /iPhone|iPod/i.test(ua);
			const androidPhone = /Android/i.test(ua) && /Mobile/i.test(ua);
			return iPhone || androidPhone;
		} catch(_) { return true; }
	};
	const isLandscape = () => {
		try {
			if (window.matchMedia) {
				const mq = window.matchMedia('(orientation: landscape)');
				// Safari < 16 uses addListener; still return .matches
				if (typeof mq.matches === 'boolean') return mq.matches;
			}
		} catch(_) {}
		return (Math.max(window.innerWidth||0, 0) > Math.max(window.innerHeight||0, 0));
	};
	const isFullscreenActive = () => {
		try {
			if (document.fullscreenElement && document.fullscreenElement.tagName && document.fullscreenElement.tagName.toLowerCase() === 'video') return true;
		} catch(_) {}
		try { return document.body.classList.contains('fs-playing'); } catch(_) { return false; }
	};
	const update = () => {
		try {
			const shouldShow = isPhone() && isLandscape() && !isFullscreenActive();
			if (shouldShow) rotateEl.classList.add('is-visible');
			else rotateEl.classList.remove('is-visible');
		} catch(_) {}
	};
	// Expose for slideshow FS handlers to call after toggling classes
	try { window.__updateRotateMessage = update; } catch(_) {}
	// Listen to relevant changes
	try { window.addEventListener('resize', update, { passive: true }); } catch(_) {}
	try {
		if (window.matchMedia) {
			const mq = window.matchMedia('(orientation: landscape)');
			if (typeof mq.addEventListener === 'function') mq.addEventListener('change', update);
			else if (typeof mq.addListener === 'function') mq.addListener(update);
		}
	} catch(_) {}
	try { window.addEventListener('orientationchange', update, { passive: true }); } catch(_) {}
	try { document.addEventListener('fullscreenchange', update); } catch(_) {}
	// Initial state
	try { update(); } catch(_) {}
})();

